import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Modal as RACModal } from 'react-aria-components';
import { ModalOverlay } from './ModalOverlay.js';
export const Modal = forwardRef(function Modal({ overlayClassName, 
// RAC defaults isDismissable to false, we prefer true so we extract it here to override it
isDismissable = true, ...props }, forwardedRef) {
    return (_jsx(ModalOverlay, { ...props, ref: forwardedRef, className: overlayClassName, isDismissable: isDismissable, children: _jsx(RACModal, { ...props, isDismissable: isDismissable }) }));
});
//# sourceMappingURL=Modal.js.map